import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";

const getImagesByDevice = (device) => {
  const suffix = device === "mobile" ? "-mobile" : device === "tablet" ? "-tab" : "-web";
  
  return [
    `./hdfc-logo${suffix}.png`,
    `./godrej-logo${suffix}.png`,
    `./club-logo${suffix}.png`,
    `./rlb-logo${suffix}.png`,
    `./smfg-logo${suffix}.png`,
    `./media-kit-logo${suffix}.png`,
    `./indiabulls-logo${suffix}.png`,
    `./kotak_Mahindra-logo${suffix}.png`,
    `./au-logo${suffix}.png`,
    `./utkarsh${suffix}.png`
  ];
};

const ScrollContainer = styled(Box)({
  display: "flex",
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: "100%",
  position: "relative",
});

const ScrollContent = styled(Box)({
  display: "flex",
  animation: "scroll 30s linear infinite",
  "@keyframes scroll": {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-50%)" },
  },
});

const Partners = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(min-width:601px) and (max-width:960px)');
  
  const deviceType = isMobile ? "mobile" : isTablet ? "tablet" : "web";
  const images = getImagesByDevice(deviceType);

  return (
    <>
             <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          marginTop:"2%"
        }}
      >
        <Box
          sx={{ width: "40px", height: "2px", backgroundColor: "#004AAD" }}
        />
        <Typography variant="h8" sx={{ fontWeight: "bold", color: "#004AAD" }}>
        Our Trusted Lending Partners
        </Typography>
      </Box>
      <Box textAlign="center" marginTop={1}>
        {/* Subtitle */}
        <Typography
          variant="h6"
          sx={{
            mt: 1,
            mb: 4,
            fontWeight: "bold",
            color: "#333333",
            textAlign: "center",
          }}
        >
      We partner with top lenders for secure and seamless funding
        </Typography>
      </Box>
       <ScrollContainer>
 
      <ScrollContent>
        {[...images, ...images].map((img, index) => (
          <Box key={index} sx={{ minWidth: isMobile ? "100px" : isTablet ? "130px" : "150px", mx: 2, padding:"20px" }}>
            <img 
              src={img} 
              alt={`partner-${index}`}  
              height={isMobile ? 40 : isTablet ? 50 : 60} 
              style={{ maxWidth: "100%" }}
            />
          </Box>
        ))}
      </ScrollContent>
    </ScrollContainer>     
    </>

  );
};

export default Partners;
